<template>
  <div class="c-apply">
    <member-menu />
    <sheet>

      <accordion :data="eventsList" />

      <div class="pagination-wrap">
        <pagination :pager="pager" @handlePagination="handlePagination" />
      </div>
    </sheet>
  </div>
</template>
<script>
import {
  defineComponent, watch, ref, reactive,
} from 'vue';
import { useRoute } from 'vue-router';
import MemberMenu from '@/components/Member/MemberMenu.vue';
import { applyDetailList } from '@/config/accordion';
import Accordion from '@/components/Global/Accordion.vue';
import { getEventInfoAPI } from '@/api/members';
import useRequest from '@/hooks/useRequest';

export default defineComponent({
  name: 'Apply',
  components: {
    MemberMenu,
    Accordion,
  },
  setup() {
    const route = useRoute();
    // const router = useRouter();
    const eventsList = ref([]);
    const pager = reactive({
      pageIndex: route.query?.pageIndex || 1,
      totalPage: 7,
    });

    const { request, response } = useRequest(getEventInfoAPI);
    request();

    const applyDetail = [
      {
        id: 1,
        name: '活動一',
        predict: '2021-01-01',
        birthday: '2020-12-31',
        bornHospiotal: '台大',
        area: '北部',
        hospitalName: '台安醫院',
        weeks: '35週',
        weight: '1400公克',
      },
      {
        id: 2,
        name: '活動二',
        predict: '2021-01-02',
        birthday: '2020-02-01',
        bornHospiotal: '台大',
        area: '北部',
        hospitalName: '台安醫院',
        weeks: '35週',
        weight: '1400公克',
      },
    ];

    const getEventInfo = (res) => {
      console.log('res.value', res);
      const {
        result: {
          data: eventList,
          pageCount: totalPage,
        }, status,
      } = res.value;

      if (status) {
        // eventsList.value = eventList;

        console.log('eventList', eventList);

        eventsList.value = applyDetailList(eventList);
        pager.totalPage = totalPage;

        return;
      }
      eventsList.value = [];
    };

    eventsList.value = applyDetailList(applyDetail);

    watch(response, () => {
      getEventInfo(response);
    });

    return {
      eventsList,
      // formatApplyDetailList,
    };
  },
});
</script>
<style lang="scss" scoped>

.media-wrap {
  margin-top: 70px;
}
</style>
